import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import MenuIcon from '@material-ui/icons/Menu';
import * as React from 'react';

interface IProps {
  onNavClicked(): void;
}

export default class Header extends React.Component<IProps> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    return (
      <div>
        <AppBar position="static" color="primary">
          <Toolbar>
            <IconButton color="primary" aria-label="Menu" onClick={() => this.props.onNavClicked()}>
              <MenuIcon color="secondary"/>
            </IconButton>
            <Typography variant="h6" color="secondary">
              Wadi Degla
            </Typography>
          </Toolbar>
        </AppBar>
      </div>
    );
    // return (
    //   <header className={styles.header}>
    //     <h1 className={styles.title}><strong>Boiler Plated</strong></h1>
    //   </header>
    // );
  }
}
